export default "/assets/website/images/favourite-medium-selected.svg?98a11aeb5bc0c0b36a4400b45e9345a7";